module.exports = function(bootstrap) {
    "use strict";
    bootstrap.directive('tierStatus', ["$rootScope","$state","modal","settings", function($rootScope, $state, modal, settings ) {

        return{
            restrict: 'A',
            replace: false,
            scope: {
                tierStatus: '=',
                uPenn:'=',
                iconCode: '='
            },
            template:
            '<span data-skip-open="true" class="network" >'+
            '<button data-skip-open="true" data-ng-class="{\'network-margin-fix\': tierLevel==null}" data-ng-if="(!(tierStatus && tierLevel && tierName[tierStatus][tierLevel].disclaimerText)) && Upenn!==\'U\'"  class="tooltipPremier">'+
            '<span data-skip-open="true" class=\"hm-icon icon-2tiers-standard ng-scope icon-height25\" data-ng-show="showIcon(\'2s\')"></span>'+
            '<span data-skip-open="true" class=\"hm-icon icon-2tiers-enhanced ng-scope icon-height25\" data-ng-show="showIcon(\'2e\')"></span>'+
            '<span data-skip-open="true" class=\"hm-icon icon-3tiers-standard ng-scope icon-height25\" data-ng-show="showIcon(\'3s\')"></span>'+
            '<span data-skip-open="true" class=\"hm-icon icon-3tiers-enhanced ng-scope icon-height25\" data-ng-show="showIcon(\'3e\')"></span>'+
            '<span data-skip-open="true" class=\"hm-icon icon-3tiers-preferred ng-scope icon-height25\" data-ng-show="showIcon(\'3p\')"></span>'+
            '<span data-skip-open="true" data-ng-class=colorChange class=\"align-icons\">{{tierStatus}}</span>'+
            '<!--North Dakota custom logic to provide tooltip text on hover instead of button click/-->'+
            '<span data-ng-if="isND" class="tooltiptextPremier" data-ng-bind-html="ndTierName[tierStatus][tierLevel].disclaimerText"></span>'+
            '<span class="accessibility">Tiers</span>'+
            '</button>'+
            '<button data-ng-class="{\'network-margin-fix\': tierLevel==null}" data-ng-if="(tierStatus&&tierLevel&&tierName[tierStatus][tierLevel].disclaimerText)&&Upenn!==\'U\'" data-skip-open="true" data-tooltip="tierStatus&&tierLevel&&tierName[tierStatus][tierLevel].disclaimerText" class="tooltipPremier">'+
            '<span data-ng-if="!isND" data-skip-open="true" class=\"hm-icon icon-2tiers-standard ng-scope icon-height25\" data-ng-show="showIcon(\'2s\')"></span>'+
            '<span data-skip-open="true" class=\"hm-icon icon-2tiers-enhanced ng-scope icon-height25\" data-ng-show="showIcon(\'2e\')"></span>'+
            '<span data-skip-open="true" class=\"hm-icon icon-3tiers-standard ng-scope icon-height25\" data-ng-show="showIcon(\'3s\')"></span>'+
            '<span data-skip-open="true" class=\"hm-icon icon-3tiers-enhanced ng-scope icon-height25\" data-ng-show="showIcon(\'3e\')"></span>'+
            '<span data-skip-open="true" class=\"hm-icon icon-3tiers-preferred ng-scope icon-height25\" data-ng-show="showIcon(\'3p\')"></span>'+
            '<span data-skip-open="true" data-ng-class=colorChange class=\"align-icons \">{{tierStatus}}</span>'+
            '<span data-ng-if="isND" class="tooltiptextPremier" data-ng-bind-html="ndTierName[tierStatus][tierLevel].disclaimerText"></span>'+
            '<span class="accessibility">Tiers</span>'+
            '</button>'+

            '<button data-skip-open="true" data-ng-if="uPenn===\'U\'" data-tooltip="upenn">'+
            '<span data-skip-open="true" class=\"hm-icon icon-alert ng-scope icon-height25\"></span>' +
            '<span data-skip-open="true" class=\"align-icons\">Heart & lung transplant notice</span>'+
            '<span class="accessibility">Tiers</span>'+
            '</button>'+

            '</span>',

            controller: ["$scope","brand","sessionData", function($scope, brand, sessionData) {
                $scope.upenn="This surgeon is conditionally in-network for heart and lung transplants.";
                $scope.isND = brand.current.sharedBrandCode.toLowerCase() == 'ndbcbs';
                if($scope.tierStatus){$scope.tierStatus=$scope.tierStatus.toUpperCase();}

                $scope.tierLevel =  settings.searchParams.maxProductTiers == null ? '0' : settings.searchParams.maxProductTiers;
                if(sessionData && sessionData.loggedIn){
                    $scope.ndTierName = {
                        "STANDARD BENEFIT LEVEL": {
                            '0': {
                                disclaimerText:"You have two levels of in-network benefits. The Standard Benefit Level generally has higher out-of-pocket costs than Premier. Please view your Benefit Booklet in the <a href='/mbr/#!/coverage/coverage-summary/' class=\"tierHyperLink\" target='_blank'>Coverage section</a> for covered services and what you’d pay under each benefit level."
                            },
                            '2': {
                                disclaimerText:"You have two levels of in-network benefits. The Standard Benefit Level generally has higher out-of-pocket costs than Premier. Please view your Benefit Booklet in the <a href='/mbr/#!/coverage/coverage-summary/' class=\"tierHyperLink\" target='_blank'>Coverage section</a> for covered services and what you’d pay under each benefit level."
                            }
                        },
                        "PREMIER BENEFIT LEVEL": {
                            '0': {
                                disclaimerText:"You have two levels of in-network benefits. The Premier Benefit Level generally has the lowest out-of-pocket costs. Please view your Benefit Booklet in the <a href='/mbr/#!/coverage/coverage-summary/' class=\"tierHyperLink\" target='_blank'>Coverage section</a> for covered services and what you’d pay under each benefit level."
                            },
                            '2': {
                                disclaimerText:"You have two levels of in-network benefits. The Premier Benefit Level generally has the lowest out-of-pocket costs. Please view your Benefit Booklet in the <a href='/mbr/#!/coverage/coverage-summary/' class=\"tierHyperLink\" target='_blank'>Coverage section</a> for covered services and what you’d pay under each benefit level."
                            }
                        }

                    };
                }else{
                    $scope.ndTierName = {
                        "STANDARD BENEFIT LEVEL": {
                            '0': {
                                disclaimerText:"You have two levels of in-network benefits. The Standard Benefit Level generally has higher out-of-pocket costs than Premier. Please <a href='/home/' class=\"tierHyperLink\" target='_blank'>log in</a> to your online member services account to review your plan documents for covered services and what you’d pay under each benefit level."
                            },
                            '2': {
                                disclaimerText:"You have two levels of in-network benefits. The Standard Benefit Level generally has higher out-of-pocket costs than Premier. Please <a href='/home/' class=\"tierHyperLink\" target='_blank'>log in</a> to your online member services account to review your plan documents for covered services and what you’d pay under each benefit level."
                            }
                        },
                        "PREMIER BENEFIT LEVEL": {
                            '0': {
                                disclaimerText:"You have two levels of in-network benefits. The Premier Benefit Level generally has the lowest out-of-pocket costs. Please <a href='/home/' class=\"tierHyperLink\" target='_blank'>log in</a> to your online member services account to review your plan documents for covered services and what you’d pay under each benefit level."
                            },
                            '2': {
                                disclaimerText:"You have two levels of in-network benefits. The Premier Benefit Level generally has the lowest out-of-pocket costs. Please <a href='/home/' class=\"tierHyperLink\" target='_blank'>log in</a> to your online member services account to review your plan documents for covered services and what you’d pay under each benefit level."
                            }
                        }

                    };
                }
                $scope.tierName = {

                    "IN NETWORK TIER 1": {
                        2: {
                            disclaimerText:"Your out-of-pocket costs are lowest when you visit providers in this tier. You can use any tier at any time during your plan year. Do you want to stay in tier 1? Make sure both the doctor and location you are visiting are in that tier.",
                            iconCode:"2e",
                            cssClass:"two-enhanced"
                        }
                    },

                    "IN NETWORK TIER 2": {
                        2: {
                            disclaimerText:"When you visit providers in tier 2, your costs are higher than tier 1. You can use any tier at any time during your plan year.",
                            iconCode:"2s",
                            cssClass:"two-standard"
                        }
                    },

                    "TIER 1": {
                        2: {
                            disclaimerText:"Your out-of-pocket costs are lowest when you visit providers in this tier. You can use any tier at any time during your plan year. Do you want to stay in tier 1? Make sure both the doctor and location you are visiting are in that tier.",
                            iconCode:"2e",
                            cssClass:"two-enhanced"
                        }
                    },

                    "TIER 2": {
                        2: {
                            disclaimerText:"When you visit providers in tier 2, your costs are higher than tier 1. You can use any tier at any time during your plan year.",
                            iconCode:"2s",
                            cssClass:"two-standard"
                        }
                    },

                    "ENHANCED BENEFIT LEVEL": {

                        2: {
                            disclaimerText:"You have 2 levels of in-network benefits. The Enhanced Value level of benefits generally has the lowest out-of-pocket costs.\n \nCheck with both the doctor and facility to get care at this level.",
                            iconCode:"2e",
                            cssClass:"two-enhanced"
                        },

                        3: {
                            disclaimerText:"You have 3 levels of in-network benefits. The Enhanced Value  level of benefits generally has higher out-of-pocket costs than the Preferred Value level of benefits.",
                            iconCode:"3e",
                            cssClass:"three-enhanced"
                        }
                    },

                    "STANDARD BENEFIT LEVEL": {
                        2: {
                            disclaimerText:"You have 2 levels of in-network benefits. The Standard Value level of benefits generally has the highest in-network out-of-pocket costs.",
                            iconCode:"2s",
                            cssClass:"two-standard"

                        },

                        3: {
                            disclaimerText:"You have 3 levels of in-network benefits. The Standard Value level of benefits generally has the highest in-network out-of-pocket costs.",
                            iconCode:"3s",
                            cssClass:"three-standard"
                        }
                    },

                    "PREFERRED BENEFIT LEVEL": {
                        3: {
                            disclaimerText:"You have 3 levels of in-network benefits. The Preferred Value level of benefits generally has the lowest out-of-pocket costs.\n \n Check with both the doctor and facility to get care at this level.",
                            iconCode:"3p",
                            cssClass:"three-preferred"
                        }
                    }
                };

                $scope.showIcon = function(input) {
                    if($scope.tierStatus && $scope.tierLevel && $scope.tierName[$scope.tierStatus] && $scope.tierName[$scope.tierStatus][$scope.tierLevel] &&
                        $scope.tierName[$scope.tierStatus][$scope.tierLevel].iconCode) {
                        if( $scope.tierName[$scope.tierStatus][$scope.tierLevel].iconCode === input) {
                            $scope.colorChange = $scope.tierName[$scope.tierStatus][$scope.tierLevel].cssClass;

                        }
                        return $scope.tierStatus && $scope.tierLevel && $scope.tierName[$scope.tierStatus][$scope.tierLevel].iconCode &&
                            $scope.tierName[$scope.tierStatus][$scope.tierLevel].iconCode === input;


                    }
                    return false;
                };

            }]
        };
    }]);
};